<template>
  <div class="header-menu">
    <el-row class="header-menu__wrapper">
      <el-col :span="20">
        <div class="header-nav">
          <ul class="clearfix">
            <li
              class="header-nav__item"
              v-for="(item, index) of unionHead.menuItems"
              :key="index"
              :class="{
                'header-nav__item_active': item.name === '演出',
              }"
            >
              <a :href="item.url">
                <span class="header-nav__item_ch">{{ item.name }}</span>
              </a>
            </li>
          </ul>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="header-search">
          <div class="header-search__inner">
            <input
              type="text"
              :placeholder="TLang('搜索', 'home')"
              class="header-search__input"
              @keyup.enter="onSubmit"
            />
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { gioClickHandle as gioHandle, getQueryString } from "../../utils";
export default {
  props: {
    unionHead: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    goGio(isCiUrl, key) {
      gioHandle("DF_elementClick", {
        df_channle: "演出",
        df_pagename: "搜索结果页",
        df_modulename: "搜索关键词",
        df_elementname: "搜索关键词",
        df_searchKeyword: key,
        df_pageType: isCiUrl ? "词链" : "",
      });
    },
    onSubmit(ev) {
      const val = ev.target.value.trim();
      this.apis.headerApi
        .getSearchUrl({ keyword: val })
        .then((res) => {
          if (res && res.body && res.body.linkUrl) {
            this.goGio(true, val);
            window.df_sdk_common.location.href = res.body.linkUrl;
          } else {
            this.goGio(false, val);
            const origin = window.location.origin;
            const city = this.publicMethod.getQueryString("city");

            window.df_sdk_common.location.href = `${origin}/health/search?keywords=${val}&city=${city}`;
          }
        })
        .catch((err) => {
          this.goGio(false, val);
          const origin = window.location.origin;
          const city = this.publicMethod.getQueryString("city");

          window.df_sdk_common.location.href = `${origin}/health/search?keywords=${val}&city=${city}`;
        });
      // const val = ev.target.value.trim();
      // const origin = window.location.origin;
      // const city = this.publicMethod.getQueryString("city");

      // window.df_sdk_common.location.href = `${origin}/health/search?keywords=${val}&city=${city}`;
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  &-menu {
    background-color: #1a4a9e;
    height: 48px;
    &__wrapper {
      .wrapper();
    }
  }
  &-nav {
    &__item {
      float: left;
      font-size: 14px;
      line-height: 48px;
      padding-left: 20px;
      padding-right: 20px;
      > a {
        display: block;
        color: #fff;
      }
      &:hover {
        transform: skewX(160deg);
        background-color: #e5152e;
        > a {
          transform: skewX(-160deg);
        }
      }
      &_active {
        transform: skewX(160deg);
        background-color: #e5152e;
        > a {
          transform: skewX(-160deg);
        }
      }
    }
  }
  &-search {
    display: table;
    width: 100%;
    height: 34px;
    padding-left: 15px;
    padding-right: 15px;
    background-color: #fff;
    border-radius: 20px;
    margin-top: 7px;
    &__inner {
      display: table-cell;
      vertical-align: middle;
    }
    &__input {
      box-sizing: border-box;
      width: 100%;
      height: 24px;
      padding-top: 2px;
      padding-bottom: 2px;
      font-size: 14px;
      background-color: #fff;
      background-image: none;
      border: none;
      outline: none;
      &::-webkit-input-placeholder {
        color: #999;
      }
      &::-moz-input-placeholder {
        color: #999;
      }
      &:-ms-input-placeholder {
        color: #999;
      }
    }
  }
}
</style>
